import { useState, useRef, useEffect } from "react";
import OutsideClickHandler from "../OutsideClickHandler";

export default function Dropdown({
  label = "Select",
  options = [],
  value,
  onChange,
}) {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
  const buttonRef = useRef(null);

  useEffect(() => {
    if (open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX,
        width: rect.width
      });
    }
  }, [open]);

  return (
    <>
      <div>
        <div className="relative mt-2 px-2">
          <button
            ref={buttonRef}
            type="button"
            className="relative w-full cursor-pointer rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 sm:text-sm sm:leading-6"
            aria-haspopup="listbox"
            aria-expanded="true"
            aria-labelledby="listbox-label"
            onClick={() => setOpen(!open)}
          >
            <span className="flex items-center">
              <span className="ml-3 block">
                {value ? options[value].label : label}
              </span>
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
              <svg
                className="h-5 w-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
          </button>
          {open && (
            <OutsideClickHandler
              onClickOutside={() => {
                setOpen(false);
              }}
            >
              <ul
                className="fixed z-[9999] mt-1 max-h-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                style={{
                  top: position.top,
                  left: position.left,
                  width: position.width
                }}
                tabIndex="-1"
                role="listbox"
                aria-labelledby="listbox-label"
                aria-activedescendant="listbox-option-3"
              >
                {options.length > 0 ? (
                  options.map((option, index) => (
                    <li
                      className={`text-gray-900 relative select-none py-2 pl-3 pr-9 cursor-pointer  ${
                        value - 1 === index
                          ? "bg-theme-gray"
                          : "hover:bg-gray-200"
                      }`}
                      id="listbox-option-0"
                      role="option"
                      key={index}
                      onClick={() => {setOpen(false);onChange(option.value);}}
                    >
                      <div className="flex items-center">
                        <span className="font-normal ml-3 block">
                          {option.label}
                        </span>
                      </div>
                      {value === index && (
                        <span className="text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4">
                          <svg
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </span>
                      )}
                    </li>
                  ))
                ) : (
                  <li
                    className="text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9"
                    id="listbox-option-0"
                    role="option"
                  >
                    <div className="flex items-center">
                      <span className="font-normal ml-3 block truncate">
                        No options
                      </span>
                    </div>
                  </li>
                )}
              </ul>
            </OutsideClickHandler>
          )}
        </div>
      </div>
    </>
  );
}
